import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, from, of, switchMap, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadDirectlyService {
  BACKEND_URL = "";
  constructor(public httpClient: HttpClient) {
    this.BACKEND_URL = environment.BACKEND_URL;
  }

  mountUrlCroped(url: string): string{
    let fullUrl = url.split('/');
    let filename = fullUrl.pop();
    const basePath = "https://s3.sa-east-1.amazonaws.com/blukitsite.assets/produtos/croped/";
    let urlCroped = basePath + filename;

    return urlCroped;
  }

  getFileNameByUrl(url: string): string {
    let fullUrl = url.split('/');
    let filename = fullUrl.pop();
    if (filename)
      return filename;
    return "";
  }

  verifyExistyUrlCroped(url: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      let image = new Image();
      image.onload = function () {
        if (image.width > 0 && image.height > 0) {
          resolve(true);
        } else {
          resolve(false);
        }
      };

      image.onerror = function() {
        console.error('Link inválido. A imagem não pôde ser carregada. Url: ' + url);
        resolve(false);
      };
      image.src = url;
    });
  }



  async getUrlCroped(url:string){
    let urlCroped = this.mountUrlCroped(url);

    let exist = await this.verifyExistyUrlCroped(urlCroped);
    if(exist){
      return urlCroped;
    }
    return null;
  }

  uploadProductCropDirectlyS3(file: File) {
    let urlUpload = '';

    return this.getUrlUploadProductCrop(file.name).pipe(
      switchMap((url) => {
        urlUpload = url.uploadUrl.split('?')[0];
        return from(fetch(url.uploadUrl, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': 'multipart/form-data',
            'Cache-Control': 'none',
            'Content-Disposition': 'attachment'
          }
        })).pipe(
          catchError((error) => {
            return throwError('Erro ao fazer a requisição.');
          })
        );
      }),
      switchMap((response) => {
        if (response.ok) {
          return of(urlUpload);
        } else {
          throw new Error('Erro ao fazer a requisição.');
        }
      }),
      catchError((error) => {
        return throwError(error);
      })
    );
  }


  getUrlUploadProductCrop(fileName:string): Observable<{uploadUrl:string}> {
    let url = `${this.BACKEND_URL}api/upload-directly/produtos/crop?fileName=${fileName}`;
    return this.httpClient.get<{uploadUrl:string}>(url)
  }
}
